import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import success_icon from "../../assets/success_icon.svg";
import copy_icon from "../../assets/icons/copy_small.svg";

//Btns
import back_btn from "../../assets/buttons/back_btn.svg";
import next_btn from "../../assets/buttons/next_btn.svg";
import { MOBILE } from "../../constants/breakpoints";
import { useNavigate } from "react-router-dom";
import colors from "../../constants/colors";

const SuccesSection = () => {
  const navigate = useNavigate();

  return (
    <>
      <section
        css={css`
          display: flex;
          margin-top: 40px;
          border: 1px solid #ccc4b3;
          border-radius: 12px;
          padding: 32px;
          flex-direction: column;

          @media (max-width: ${MOBILE}px) {
            width: 100%;
            height: max-content;
            padding: 16px 24px;
          }
        `}
      >
        <div
          css={css`
            display: 100%;
            display: flex;
          `}
        >
          <span
            css={css`
              display: flex;
              flex-direction: column;
              width: 75%;
              margin-top: 70px;

              @media (max-width: ${MOBILE}px) {
                margin-top: 0;
              }
            `}
          >
            <h1
              css={css`
                font-weight: 700;
                font-size: 24px;
                margin: 0;

                @media (max-width: ${MOBILE}px) {
                  font-size: 16px;
                }
              `}
            >
              Token has been minted!
            </h1>
            <p
              css={css`
                font-weight: 500;
                font-size: 16px;
                margin: 0;
                margin-top: 16px;
                color: #757272;

                @media (max-width: ${MOBILE}px) {
                  display: none;
                }
              `}
            >
              If it is ever lost or stolen, move your original asset from its
              cold storage location and we'll immediately burn the Proxy Token
              so you can create another to replace it!
            </p>
          </span>
          <img
            css={css`
              width: 128px;
              height: 128px;

              @media (max-width: ${MOBILE}px) {
                width: 64px;
                height: 64px;
              }
            `}
            src={success_icon}
            alt=""
          />
        </div>
        {/* Mobile view text */}
        <p
          css={css`
            font-weight: 500;
            font-size: 16px;
            margin: 0;
            margin-top: 16px;
            color: #757272;

            @media (min-width: ${MOBILE + 1}px) {
              display: none;
            }
          `}
        >
          If it is ever lost or stolen, move your original asset from its cold
          storage location and we'll immediately burn the Proxy Token so you can
          create another to replace it!
        </p>
        <p
          onClick={() => {
            navigate("/proxy-tokens-list");
          }}
          css={css`
                cursor: pointer;
                font-weight: 700;
                font-size: 24px;
                margin-top: 12px;
                margin-bottom: 0px;
                color: ${colors.INTERFACE_COLORS_BASALT};
                &:hover {
                  transform: translateX(30px) scale(1.2);
                  transition: all 0.2s ease-in-out;
                }
                text-decoration: underline;

                @media (max-width: ${MOBILE}px) {
                  font-size: 16px;
                }
              `}
        >
          View Proxy Tokens
        </p>
      </section>
    </>
  );
};

export default SuccesSection;
